/**
 * Feb 2026 · /b/:slug — Public promo short-link redirect.
 * Resolves the slug via GET /public/b/:slug then navigates to the
 * booking widget with the promo code pre-filled + a `sl` query param
 * that the widget uses to attribute funnel steps to this share link.
 */
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function PromoShareLandingRedirect() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!slug) { setErr("Missing link"); return; }
    api.get(`/public/b/${slug}`)
      .then((r) => {
        const { workspace_id, code } = r.data || {};
        if (!workspace_id) { setErr("Link not found"); return; }
        // Replace so the ugly /b/slug doesn't sit in history
        nav(`/book/${workspace_id}?promo=${encodeURIComponent(code)}&sl=${encodeURIComponent(slug)}`,
             { replace: true });
      })
      .catch(() => setErr("This link is no longer active."));
  }, [slug, nav]);
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center",
                    fontFamily: "system-ui, -apple-system, sans-serif", background: "#0B2545", color: "white" }}
         data-testid="promo-share-landing">
      <div style={{ textAlign: "center", padding: 24 }}>
        {err ? (
          <>
            <div style={{ fontSize: 42, marginBottom: 8, opacity: 0.6 }}>–</div>
            <h1 style={{ margin: 0, fontSize: 18 }}>{err}</h1>
            <p style={{ fontSize: 12, opacity: 0.7, marginTop: 8 }}>The offer may have ended or been paused.</p>
          </>
        ) : (
          <>
            <div style={{ fontSize: 11, letterSpacing: 3, textTransform: "uppercase", opacity: 0.7 }}>Redirecting</div>
            <h1 style={{ margin: "12px 0 0", fontSize: 22 }}>Loading your offer…</h1>
          </>
        )}
      </div>
    </div>
  );
}
